<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import AnalyticsList from "../components/pages/analytics/list.vue";
export default {
  components: { AnalyticsList },
  name: "Analytics",
  data() {
    return {
      tabIndex: 0,
      tabs: ["activities", "workouts", "warmups", "stretch-flows"],
      currentPage: 1,
      journeyLevel: null,
    };
  },
  ...mapGetters({
    currentPaginationPage: "commons/currentPaginationPage",
    currentDataList: "commons/currentDataList",
    fieldOptionsChunked: "commons/fieldOptionsChunked",

    journeyList() {
      return this.$store.getters[`commons/journeyList`];
    },
    getLevel() {
      console.log(this.$store.getters[`commons/journeyList`]);
      if (this.$store.getters[`commons/journeyList`]) {
        var journey = this.$store.getters[`commons/journeyList`];
      }
      // if (journey.levels) {
      //   return journey.levels.map((data) => {
      //     return {
      //       text: data.value,
      //       value: data.id,
      //     };
      //   });
      // }
    },
  }),
  watch: {
    tabIndex(val) {
      console.log(val);
    },
  },
  mounted() {
    //this.$store.dispatch(`commons/getFieldOptions`);
    this.$store.commit("commons/setPreloader", true);
    this.$store.dispatch("commons/getJourney").then((res) => {
      var journey = res.find((journey) => journey.id == 1);
      this.journeyLevel = journey.levels[0].id;
      this.$store.dispatch("commons/getJourneyReport", {
        journey: 1,
        level: journey.levels[0].id,
        status: [],
        equipments: [],
        primary_level: false,
        benefits: ["benefit_1"],
      });
    });

    this.$store
      .dispatch("commons/listByType", {
        limit: 25,
        type: "activities",
        offset: 1,
        search: null,
      })
      .then(() => {
        this.$store.commit("commons/setPreloader", false);
      });
  },
};
</script>
<style lang="scss">
.data-listing-tabs {
  .tabs {
    .card-header {
      .card-header-tabs {
        li {
          width: auto;
          a {
            padding-left: 25px;
            padding-right: 25px;
            border-bottom: 0 !important;
            background: #efefef;
            text-transform: capitalize;
            &.active {
              border-bottom: 0 !important;
            }
            &.disabled {
              background: transparent;
              cursor: not-allowed;
            }
          }
        }
      }
    }
  }
}
</style>>

<template>
  <div>
    <b-card no-body class="data-listing-tabs">
      <b-tabs card v-model="tabIndex">
        <b-tab title="All" active>
          <analytics-list :type="'activities'" :journeyLevel="journeyLevel">
          </analytics-list>
        </b-tab>
        <b-tab title="Workouts">
          <analytics-list :type="'workouts'" :journeyLevel="journeyLevel">
          </analytics-list>
        </b-tab>
        <!-- <b-tab title="Warm Up">
          <analytics-list :type="'warmups'"> </analytics-list>
        </b-tab>
        <b-tab title="Stretch Flow">
          <analytics-list :type="'stretch-flows'"> </analytics-list>
        </b-tab> -->
      </b-tabs>
    </b-card>
  </div>
</template>
